import types from '../../utils/actionTypes';

export const viewNewOrders = () => async (dispatch) =>{
    dispatch({type: types.NEWORDERS_TAB})
}

export const viewInProgressOrder = () => async (dispatch) =>{
    dispatch({type: types.INPROGRESS_TAB})
}

export const viewShipmentOrders = () => async (dispatch) =>{
    dispatch({type: types.SHIPMENT_TAB})
}

export const viewDeliveryOrders = () => async (dispatch) =>{
    dispatch({type: types.DELIVERY_TAB})
}